<template>
	<div v-loading="loading"></div>
</template>

<script setup>
import { ref, onMounted } from "vue";
const loading = ref(false)
onMounted(() => {
	loading.value = true
	window.location.href="https://h5.tui.hongguotui.com/app/detail.html?appId=269661&tui=1722418571260"
})
</script>

<style>
</style>